export const products = [
	{
		id: 1,
		img: "/images/github.png",
		link: "https://github.com/gauravkataria21",
		name: "Github-Link",
	},
	{
		id: 2,
		img: "/images/blog.png",
		link: "https://tech-bloggy-app.herokuapp.com/",
		name: "Tech-Blog",
	},
	{
		id: 3,
		img: "/images/outfit.png",
		link: "https://outfit-delight.netlify.app/",
		name: "Outfit-Delight",
	},

	{
		id: 4,
		img: "/images/web.png",
		link: "https://webhose-cloud-hosting.netlify.app/index.html",
		name: "Webhose.",
	},

	{
		id: 5,
		img: "/images/travelly.png",
		link: "https://travelly-adventure.netlify.app/",
		name: "Travelly",
	},
	{
		id: 6,
		img: "/images/pizza.png",
		link: "https://pizzas-restro.herokuapp.com/",
		name: "React-Pizza",
	},
];
